import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { TextField } from '@components/shared/vms/CommonTypes';
import { ProductCode } from '@contracts';
import { getNodesForLocale } from '@utils/language';
import useCurrentURLLanguage from '@utils/useCurrentUrlLanguage';

export enum ProductTypes {
  PeriodCare = 'Period Care',
  SelfCare = 'Self-care',
  BalmsAndCreams = 'Balms & Creams',
  Accessories = 'Accessories',
  Gifts = 'Gifts',
  VaginalHealth = 'Vaginal Health'
}

export enum ButtonTypesCatalogue {
  ChooseABox = 'choose-box',
  BuyNow = 'buy-now',
  AddToCart = 'add-to-cart',
  JoinWaitlist = 'join-waitlist'
}

export interface ProductData {
  product_code: ProductCode;
  product_category: ProductTypes;
  product_categories: TextField;
  product_title: TextField;
  product_description: TextField;
  link: TextField;
  product_code_override: TextField;
  price: string;
  button_type: ButtonTypesCatalogue;
  product_image: {
    dimanesions?: {
      width: number;
      height: number;
    };
    alt?: string;
    copyright?: string;
    url?: string;
    gatsbyImageData: IGatsbyImageData;
  };
  product_video: {
    url?: string;
  };
  priority?: boolean;
  variable_price?: boolean;
  show_in_countries?: TextField;
  country_sorting?: TextField;
  background?: TextField;
  from_price_product_code?: TextField;
  available_in?: TextField;
  onlyshowcase?: boolean;
}
interface ShopProductsOptions {
  isProductShowcase?: boolean;
}

export const query = graphql`
  query getShopProducts {
    allPrismicEcommerceShopProducts {
      nodes {
        lang
        data {
          products {
            variable_price
            product_code
            product_title {
              text
            }
            product_description {
              text
            }
            button_type
            product_category {
              uid
              slug
            }
            product_categories {
              text
            }
            product_code_override {
              text
            }
            priority
            product_image {
              alt
              gatsbyImageData
              url
            }
            product_video {
              url
            }
            link {
              text
            }
            show_in_countries {
              text
            }
            country_sorting {
              text
            }
            from_price_product_code {
              text
            }
            available_in {
              text
            }
            onlyshowcase
          }
        }
      }
    }
  }
`;

export const getShopProducts = ({ isProductShowcase = false }: ShopProductsOptions = {}): ProductData[] => {
  const { allPrismicEcommerceShopProducts } = useStaticQuery(query);
  const { nodes } = allPrismicEcommerceShopProducts;
  const currentLanguage = useCurrentURLLanguage();
  const shopProductsData = getNodesForLocale(nodes, currentLanguage.locale);

  if (!shopProductsData) {
    return [];
  }

  let products = shopProductsData?.data?.products;

  if (!products) {
    return [];
  }

  if (!isProductShowcase) {
    products = products.filter((product: ProductData) => !product.onlyshowcase);
  }

  return products;
};
